import { VendorList } from 'consent-string';
import { lazyGdprVendorList } from 'owa-gdpr-ad-vendorlist';

let vendorListCache: VendorList;

export default async function fetchVendorList() {
    if (!vendorListCache) {
        let getVendorList = await lazyGdprVendorList.import();
        vendorListCache = getVendorList();
    }

    return vendorListCache;
}
